export default __webpack_public_path__ + "static/media/francheville25.1c1c9b3c.jpg";